import { FeatureFlagOptions } from './types'

export const GROWTH_BOOK_FEATURE_FLAGS: Record<string, FeatureFlagOptions> = {} as const
